import React, { useEffect, useRef } from 'react';

interface Props {
  programmaticConversionScriptSrc?: string;
  programmaticConversionImgSrc?: string;
}

const ProgrammaticConversionTracking: React.FC<Props> = ({
  programmaticConversionScriptSrc,
  programmaticConversionImgSrc
}) => {
  const programmaticWrapperDiv = useRef(null);

  useEffect(() => {
    // Add programmatic conversion script if if needs to be added and it's not added yet.
    if (
      programmaticConversionScriptSrc &&
      programmaticWrapperDiv.current &&
      !(programmaticWrapperDiv.current as any).querySelector('#programmatic-conversion-script')
    ) {
      const programmaticScriptElement = document.createElement('script');
      programmaticScriptElement.id = 'programmatic-conversion-script';
      programmaticScriptElement.src = programmaticConversionScriptSrc;
      programmaticScriptElement.setAttribute('data-cookieconsent', 'marketing');
      programmaticScriptElement.type = 'text/plain';
      (programmaticWrapperDiv.current as any).appendChild(programmaticScriptElement);
    }
  }, [programmaticConversionScriptSrc, programmaticWrapperDiv]);

  return (
    <div
      className="position-absolute top-0 start-0"
      style={{ width: 1, height: 1 }}
      ref={programmaticWrapperDiv}
    >
      {!!programmaticConversionImgSrc && programmaticConversionImgSrc !== '' && (
        <img
          id="programmatic-conversion-pixel"
          data-cookieblock-src={programmaticConversionImgSrc}
          data-cookieconsent="marketing"
          src="data:,"
          width="1"
          height="1"
          alt="programmatic conversion pixel"
        />
      )}
    </div>
  );
};

export default ProgrammaticConversionTracking;
